<template>
    <div>
      <div class="d-flex justify-content-between">
        <h1 class="page-header">{{ $t('academicReport.pageTitle') }}</h1>
        <ts-breadcrumb
          :items="[
            { text: $t('toHomePage'), href: '/' },
            {
              text: $t('academicReport.pageTitle'),
              active: true
            }
          ]"
        />
      </div>
      <ts-card>
        <ts-card-wrapper>
          <div class="row">
            <div class="col-md-3">
              <ts-loading-banner :loading="loading">
                <div class="card border-0">
                  <div
                    class="card-body"
                    style="background-color: #20252a; border-radius: 5px"
                  >
                    <div class="text-gray-500">
                      <b>{{ $t('academicReport.filterCriteria') }}</b>
                    </div>
                  </div>
                  <div class="widget-list rounded-bottom">
                    <div class="row form-group mt-2">
                      <div class="col-md-12">
                        <label class="required">{{
                          $t('cashCollectionByCashier.branchName')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model.number="model.branch_id"
                          :options="branches"
                        ></a-select>
                        <div class="validate" v-if="errors.has('branch_id')">
                          {{ errors.first('branch_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label>{{
                          $t('academicReport.acYear')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model="model.ac_year_id"
                          :options="ac_year_list"
                          :loading="fetching_academic_year"
													:filter-option="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                           mode="multiple"
                          :placeholder="$t('all')"
                           @change="acYearChange"
                        ></a-select>
                      </div>
                    </div>
                    <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{
                        $t('academicReport.acTerm')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.ac_term_id"
                        :options="acTerms"
                        :show-search="true"
                        :loading="fetching_academic_term"
                        :filter-option="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        @change="acTermChange"
                        :placeholder="$t('all')"
                      ></a-select>
                    </div>
                  </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label>{{
                          $t('academicReport.classOperation')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model="model.class_id"
                          :options="class_options"
                          :show-search="true"
                          :loading="fetching_class_operation"
                          :filter-option="
                            (input, option) =>
                            option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                                "
                          @change="classChange"
                          allowClear
                          :placeholder="$t('all')"
                        ></a-select>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label class="required">{{ $t('academicReport.student') }}</label>
                        <a-select
                          style="width: 100%"
                          v-model="model.student_id"
                          :options="student_lists"
                          :show-search="true"
                          :loading="fetching_student"
                          :filter-option="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                        ></a-select>
                        <div class="validate" v-if="errors.has('student_id')">
                          {{ errors.first('student_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <ts-button
                          class="btn-block"
                          color="primary"
                          @click.prevent="preview"
                          :waiting="waiting"
                          >{{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </ts-loading-banner>
            </div>
            <div class="col-md-9">
              <ts-preview-pdf v-model="waiting" :src="src" />
            </div>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </div>
  </template>
  <script>
  import { mapActions, mapState } from 'vuex'
  import { Errors } from 'form-backend-validation'
  
  export default {
    name: 'academicReport',
    data () {
      return {
        loading: false,
        waiting: false,
        fetching_academic_year: false,
        fetching_academic_term: false,
        fetching_class_operation: false,
        fetching_student: false,
        src: '',
        errors: new Errors(),
        branches: [],
        ac_year_list: [],
        student_lists: [],
        class_options: [],
        acTerms: [],
        model: {
          branch_id: null,
          class_id: undefined,
          ac_term_id: null,
          ac_year_id: [],
          student_id: null
        }
      }
    },
    computed: {
      ...mapState('reportAcademic', ['studentStatus'])
    },
    created () {
      this.fetchData()
    },
    methods: {
      ...mapActions('reportAcademic', [
        'academicReport',
        'getBranch',
        'getYear',
        'getTerm',
        'getFormViewModel'
      ]),
      // Fetch Data
      async fetchData () {
        this.loading = true
        await this.getBranch().then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.model.branch_id = this.$store.state.authUser.default_branch_id
        })
        await this.getFormViewModel({
          fnName: 'studentProfile'
        })
          .then(response => {
            this.student_lists = response.data.studentProfile
              .map(el => ({
                value: el.student_id,
                label: el.full_name_en
              }))
          })
        .finally(() => {
            this.loading = false
          })
      },
      //onChange branch
      onBranchChange () {
        this.model.ac_year_id = []
        this.fetching_academic_year = true
        this.getYear({
          filter: {
            ac_status_id: '1,2,3',
            branch_id: this.model.branch_id
          },
          branch_id: [this.model.branch_id]
        })
          .then(response => {
            this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
              el => ({
                value: el.ac_year_id,
                label:
                  el.ac_year +
                  (el.ac_status_id == 1
                    ? ' ( Current ) '
                    : el.ac_status_id == 2
                    ? ' ( History ) '
                    : ' ( Next ) ')
              })
            )
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetching_academic_year = false
          })
      },
      async classChange (class_id) {
        this.model.student_id = null
        this.fetching_student = true
        await this.getFormViewModel({
          fnName: 'studentProfile',
          class_id: class_id,
        })
          .then(response => {
            this.student_lists = response.data.studentProfile
              .map(el => ({
                value: el.student_id,
                label: el.full_name_en
              }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
          this.fetching_student = false
        })
      },
      async acTermChange (ac_term_id) {
        this.fetching_class_operation = true
        this.model.class_id = undefined
        await this.getFormViewModel({
          fnName: 'acadmicClass',
          ac_term_id: ac_term_id,
          branch_id: this.model.branch_id
        })
        .then(response => {
          this.class_options = response.data.acadmicClass.map(el => ({
            value: el.class_id,
            label:
              el.class_name
          }))
        })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
          this.fetching_class_operation = false
        })
      },
      acYearChange() {
      this.model.ac_term_id = null
      this.model.class_id = undefined
      this.fetching_academic_term = true
      this.getTerm({
        filter: {
          acps_id: this.model.acps_id,
          ac_status_id: '1,2,3',
          ac_year_id: this.model.ac_year_id,
          branch_id: this.model.branch_id
        }
      })
        .then(response => {
          this.acTerms = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : '( Next )')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_academic_term = false
        })
    },
      preview () {
        this.waiting = true
        this.src = ''
        this.errors = new Errors()
        this.academicReport(this.model)
          .then(response => {
            this.src = response.url
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.waiting = false
          })
      }
    },
    watch: {
      'model.branch_id': function (val) {
        if (val) {
          this.onBranchChange()
        }
      }
    }
  }
  </script>
  